
export const loadingStatesKeys = {
    statsCards: "statsCards",
    trafficAnalysis: "trafficAnalysis",
    serviceBreakdown: "serviceBreakdown",
    aiFlowExperience: "aiFlowExperience",
    agentRating: "agentRating",
    reportLogs: "reportLogs",
    timeToAnswer: "timeToAnswer",
    queueDrops: "queueDrops",
    csat: "csat",
    messageTraffic: "messageTraffic",
    sentiment: "sentiment",
    notifications: "notifications",
    doctors: "doctors",
    allChats: "allChats",
    agents: "agents",
    templates: "templates"
}